<div class="content-card">
  <div class="card-header">
    <h3>{{ title }}</h3>
  </div>
  <div class="card-body">
    @if (formGroup && formControls().length > 0) {
      <form
        [formGroup]="formGroup"
        class="config-form"
      >
        @for (control of formControls(); track control.key) {
          @if (control.config.type === 'checkbox') {
            <div class="mb-4 checkbox-container">
              <input
                type="checkbox"
                [formControlName]="control.key"
                [attr.id]="control.key"
                class="form-check-input"
              />
              <label
                [for]="control.key"
                class="ms-2 form-check-label"
              >
                {{ getCheckboxLabel(control.key) }}
              </label>
            </div>
          } @else {
            <div class="mb-4">
              <kendo-label
                [for]="control.key"
                [text]="control.config.label || (control.key | titlecase)"
                [optional]="!control.config.validators?.required"
              ></kendo-label>

              @if (control.config.type === 'password') {
                <kendo-textbox
                  [formControlName]="control.key"
                  [attr.id]="control.key"
                  type="password"
                  class="w-100"
                ></kendo-textbox>
              } @else {
                <kendo-textbox
                  [formControlName]="control.key"
                  [attr.id]="control.key"
                  class="w-100"
                ></kendo-textbox>
              }

              @if (formGroup.get(control.key)?.invalid && formGroup.get(control.key)?.touched) {
                <div class="text-danger mt-1">
                  @if (formGroup.get(control.key)?.errors?.['required']) {
                    {{ control.key | titlecase }}
                    is required
                  } @else if (formGroup.get(control.key)?.errors?.['minlength']) {
                    {{ control.key | titlecase }}
                    must be at least {{ formGroup.get(control.key)?.errors?.['minlength'].requiredLength }} characters
                  } @else if (formGroup.get(control.key)?.errors?.['pattern']) {
                    {{ control.key | titlecase }}
                    has an invalid format
                  }
                </div>
              }
            </div>
          }
        }

        @if (hasFormChangedSinceTest()) {
          <div class="alert alert-warning mb-3">
            <small>
              <strong>Form has changed since last test.</strong>
              Please test the connection again before saving.
            </small>
          </div>
        }

        <div class="form-actions">
          <button
            kendoButton
            [primary]="true"
            (click)="onTestConnection()"
            [disabled]="formGroup.invalid || loading()"
            class="k-button-solid-primary"
          >
            @if (icons['checkOutline']) {
              <kendo-svgicon
                [icon]="icons['checkOutline']"
                class="me-1"
              ></kendo-svgicon>
            }
            Test Connection
          </button>
          <button
            kendoButton
            (click)="onSaveConfiguration()"
            [disabled]="formGroup.invalid || loading() || !testSuccess()"
            class="ms-2"
            [title]="
              !testSuccess() && hasFormChangedSinceTest()
                ? 'Form has changed since last test. Please test connection again.'
                : ''
            "
          >
            @if (icons['save']) {
              <kendo-svgicon
                [icon]="icons['save']"
                class="me-1"
              ></kendo-svgicon>
            }
            Save Configuration
          </button>
        </div>
      </form>
    } @else {
      <div class="loading-state">
        <p>Loading form configuration...</p>
      </div>
    }
  </div>
</div>
